import { Posthog } from '../posthog.ts'
import type { PosthogEvent } from './posthog_events.ts'

interface PosthogTrackViewParameters {
  viewId?: string // 本ビューの ID
  prevViewId: string | undefined // 本ビューの元になるビュー（もしあれば）の ID
  prevViewType: string | undefined // "kpiPivot" ならダッシュボードのドリルダウンから本ビューが開かれたことを意味する
  nodeName: string | undefined // 対象イベント: [view_sheet_custom_model_property_form]。
}

export const posthogTrackView = (eventName: PosthogEvent, parameters: PosthogTrackViewParameters): void => {
  Posthog.track(eventName, {
    viewId: parameters.viewId,
    prevViewId: parameters.prevViewId,
    prevViewType: parameters.prevViewType,
    nodeName: parameters.nodeName,
  })
}

export const posthogTrackClick = (eventName: PosthogEvent, viewId: string): void => {
  Posthog.track(eventName, {
    viewId,
  })
}
